import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import SyncIcon from "@mui/icons-material/Sync";
import { Button, Box, useTheme } from "@mui/material";
import { useContext } from "react";
import { FormContext } from "components/shared/Form";
import FormState from "components/ui/atoms/FormState";
import WithConfirmationButton from "components/ui/atoms/WithConfirmationButton";

export const FormButtonsBase = ({ children }) => {
  const theme = useTheme();

  return (
    <Box
      alignItems="center"
      justifyContent="space-between"
      p={2}
      sx={{
        zIndex: 2,
        display: "flex",
        position: "sticky",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: theme.palette_custom.white,
        boxShadow:
          "rgba(15, 15, 15, 0.016) 0px 0px 0px 1px, " +
          "rgba(15, 15, 15, 0.03) 0px 3px 6px, " +
          "rgba(15, 15, 15, 0.06) 0px 9px 24px",
      }}
    >
      {children}
    </Box>
  );
};

export const FormButtons = ({ children }) => {
  const {
    form: { control },
    formType,
    onCancel,
    onSubmit,
    onDelete,
  } = useContext(FormContext);

  return (
    <FormButtonsBase>
      <Box>
        {formType == "update" && onDelete && (
          <WithConfirmationButton
            confirmationMessage="Confirm deletion ?"
            type="submit"
            variant="outlined"
            endIcon={<DeleteIcon sx={{ scale: "0.8" }} />}
            onClick={onDelete}
          >
            Delete
          </WithConfirmationButton>
        )}
        {children}
      </Box>
      <FormState control={control} />
      <Box>
        <Button variant="outlined" onClick={onCancel} sx={{ mr: 1 }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          type="submit"
          endIcon={
            formType == "update" ? (
              <SyncIcon sx={{ scale: "0.8" }} />
            ) : (
              <AddIcon sx={{ scale: "0.8" }} />
            )
          }
          onClick={onSubmit}
        >
          {formType == "update" ? "Save" : "Create"}
        </Button>
      </Box>
    </FormButtonsBase>
  );
};

export default FormButtons;
